import React, { ReactElement } from 'react';

export default function NotAccessPage(): ReactElement {
  return (
    <h2>Aucun accès ne vous a été donné ou votre compte n&#39;existe pas, contacter votre administrateur pour obtenir un accès</h2>
  );
}
